import { render, staticRenderFns } from "./WinterServiceLogHistory.vue?vue&type=template&id=4b2d357a&scoped=true"
import script from "./WinterServiceLogHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./WinterServiceLogHistory.vue?vue&type=script&setup=true&lang=js"
import style0 from "./WinterServiceLogHistory.vue?vue&type=style&index=0&id=4b2d357a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2d357a",
  null
  
)

export default component.exports